export var BusSources = /*#__PURE__*/function (BusSources) {
  BusSources["PROJECT"] = "Project";
  BusSources["PLATFORM_GUI"] = "Platform:GUI";
  BusSources["PLATFORM"] = "Platform";
  BusSources["DEV_SERVER"] = "DevServer";
  BusSources["TS_FORK_PROCESS_PARENT"] = "TS_FORK_PROCESS:PARENT";
  BusSources["TS_FORK_PROCESS_CHILD"] = "TS_FORK_PROCESS:CHILD";
  return BusSources;
}({});